module.exports = __webpack_public_path__ + "img/logo.1b682c73.png";